// HomePage.jsx
import React from "react";
import { NavBar2 } from "../components/navigation/desktop/NavBar2";
import { Outlet } from "react-router-dom";
import { SidenavProvider } from "../components/navigation/desktop/SidenavContext";
import { SidenavContainer } from "../components/navigation/desktop/SidenavContainer";
import { Sidenav } from "../components/navigation/desktop/Sidenav";
import { AiOutlineDashboard } from "react-icons/ai";
import { FaStairs } from "react-icons/fa6";
import { TbAlignBoxRightStretch } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { useAuth } from "../AuthContext"; // Add this import

export const HomePage = () => {
    const { t } = useTranslation();
    const { isAdmin } = useAuth(); // Get admin status

    const labelDashboard = t("text_dashboard");
    const labelBlocks = t("text_floors");
    const labelEventLog = t("text_eventlog");

    // Base nav items for all users
    let sideNavItems = [
        { icon: AiOutlineDashboard, label: labelDashboard, to: "dashboard" },
        { icon: FaStairs, label: labelBlocks, to: "blocks" },
    ];

    // Add EventLog only for admin users
    if (isAdmin()) {
        sideNavItems.push({
            icon: TbAlignBoxRightStretch,
            label: labelEventLog,
            to: "eventlog"
        });
    }

    return (
        <SidenavProvider>
            <NavBar2 />
            <SidenavContainer sidenav={<Sidenav navItems={sideNavItems} />}>
                <main>
                    <Outlet />
                </main>
            </SidenavContainer>
        </SidenavProvider>
    );
};